import React from "react";
import { Link } from "react-router-dom";
import { PlaneLanding, PlaneTakeoff, Users2, Wrench, Droplets, AlertCircle, CalendarOff, ReceiptText, ShoppingCart } from "lucide-react";

const Tile = ({ icon: Icon, label, value, to, alert, testid }) => (
  <Link to={to} data-testid={testid}
    className={`group rounded-xl border px-4 py-3 flex items-center gap-3 transition-colors duration-200 ${alert ? "border-[#991B1B]/25 bg-[#FEF2F2] hover:bg-[#FDE8E8]" : "border-[#E3DED4] bg-[#F7F5F1] hover:bg-[#F1EDE6]"}`}>
    <Icon className={`h-4 w-4 shrink-0 ${alert ? "text-[#991B1B]" : "text-[#6E7A63]"}`} />
    <div className="min-w-0">
      <div className="text-[10px] uppercase tracking-wider text-[#6F6A60] truncate">{label}</div>
      <div className={`font-serif text-xl tabular ${alert ? "text-[#991B1B]" : "text-[#45423C]"}`}>{value}</div>
    </div>
  </Link>
);

export const TodayTiles = ({ t }) => (
  <div className="grid grid-cols-2 gap-3">
    <Tile testid="dash-today-arrivals" icon={PlaneLanding} label="Αφίξεις σήμερα" value={t?.arrivals ?? "—"} to="/reservations" />
    <Tile testid="dash-today-departures" icon={PlaneTakeoff} label="Αναχωρήσεις σήμερα" value={t?.departures ?? "—"} to="/reservations" />
    <Tile testid="dash-today-inhouse" icon={Users2} label="Διαμένουν (κρατήσεις)" value={t?.in_house ?? "—"} to="/reservations" />
    <Tile testid="dash-today-guests" icon={Users2} label="Επισκέπτες στο ακίνητο" value={t?.guests_in_house ?? "—"} to="/reservations" />
  </div>
);

export const OpsTiles = ({ o }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
    <Tile testid="dash-ops-maint" icon={Wrench} label="Συντήρηση ανοιχτές" value={o?.maintenance_open ?? "—"} to="/maintenance-tasks" alert={o?.maintenance_overdue > 0} />
    <Tile testid="dash-ops-maint-overdue" icon={Wrench} label="Ληξιπρόθεσμες" value={o?.maintenance_overdue ?? "—"} to="/maintenance-tasks" alert={o?.maintenance_overdue > 0} />
    <Tile testid="dash-ops-pools" icon={Droplets} label="Πισίνες χωρίς μέτρηση" value={o ? `${o.pools_missing}/${o.pools_total}` : "—"} to="/pools" alert={o?.pools_missing > 0} />
    <Tile testid="dash-ops-issues" icon={AlertCircle} label="Ανοιχτά θέματα" value={o?.issues_open ?? "—"} to="/field-ops/issues" alert={o?.issues_open > 0} />
    <Tile testid="dash-ops-leave" icon={CalendarOff} label="Άδειες προς έγκριση" value={o?.leave_pending ?? "—"} to="/leave" alert={o?.leave_pending > 0} />
    <Tile testid="dash-ops-po" icon={ShoppingCart} label="Ανοιχτές παραγγελίες" value={o?.po_open ?? "—"} to="/orders" />
    <Tile testid="dash-ops-expenses" icon={ReceiptText} label="Έξοδα σε εκκρεμότητα" value={o?.expenses_pending ?? "—"} to="/expenses" alert={o?.expenses_pending > 0} />
  </div>
);
